export default __webpack_public_path__ + "static/media/ic_mustHave_48px.40af929e.svg";